require("!!/home/uplanner/rosario-front/node_modules/script-loader/addScript.js")(require("!!/home/uplanner/rosario-front/node_modules/raw-loader/index.js!/home/uplanner/rosario-front/bower_components/pdfmake/build/vfs_fonts.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/pdfmake/build/vfs_fonts.js
// module id = 1527
// module chunks = 0